import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5661%3A7202
 *
 * @param {SvgIconProps} props - svg props
 */
export const SentIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M23 4L1 6.66667L4.66667 10.6667L12 9.71429L7.11111 13.3333V18.6667L9.55556 16L13.1579 20L23 4Z' fill={color}/>
        </SvgIcon>
    )
}

export default SentIcon
